<template>
    <ContentPage title="Privacy Policy" sub-title="Pursuant to Article 13 of Regulation (EU) 2016/679">
        <p>
            Adorea S.r.l. ("Adorea S.r.l. (Fleequid)"), with its registered office in Olgiate Comasco (CO) 22077, Via provinciale per Bizzarone, 43,
            VAT No. and Tax ID No. 04114790134, registered in the Companies' Register of Como at No. 04114790134, with a fully paid share capital of
            €10.000,00€ ("<strong>Adorea S.r.l. (Fleequid)</strong>") as data controller, hereby issues this information notice on the processing of
            your personal data pursuant to Art. 13 of Regulation (EU) no. 2016/679 ("<strong>GDPR</strong>").
        </p>

        <BaseVerticalStack as="ol" class="list-inside list-decimal">
            <li>
                <h3 class="text-highlighted inline-block font-bold">Purpose of processing and legal basis</h3>
                <p class="my-4">
                    Adorea S.r.l. (Fleequid) specialises in managing online auctions for industrial vehicles, dedicated specifically to business
                    clients. When a company registers on Adorea S.r.l. (Fleequid) to participate in an auction, it shall provide certain data with
                    reference to its contact person, i.e. name, surname, e-mail and telephone number ("<strong>Data</strong>"). Such Data shall be
                    processed by Adorea S.r.l. (Fleequid), also through electronic/digital means, exclusively for the following purposes and legal
                    basis:
                </p>
                <div class="my-4 grid grid-cols-[40px_1fr_1fr] grid-rows-[24px_1fr_1fr] gap-2">
                    <div class="font-bold">N.</div>
                    <div class="font-bold">Purpose</div>
                    <div class="font-bold">Legal Basis</div>
                    <div class="font-bold">1.1</div>
                    <div>
                        To facilitate user participation in the auction upon request, ensuring its smooth operation, and providing the opportunity to
                        contact the designated company representative in case of winning the bid
                    </div>
                    <div>Contract Execution</div>
                    <div class="font-bold">1.2</div>
                    <div>To send information material regarding the services offered by Adorea S.r.l. (Fleequid).</div>
                    <div>
                        Pursuant to Article 130. p. 4 of Legislative Decree No. 196/2003, processing is based on legitimate interest. The data subject
                        has the right to object to the processing at any time, free of charge and with ease.
                    </div>
                </div>
                <p class="my-4">
                    Providing personal data is necessary to participate in the auction and access the services of Adorea S.r.l. (Fleequid). Failure to
                    provide this data would impede participation and prevent the establishment of a contractual relationship with Adorea S.r.l.
                    (Fleequid).
                </p>
            </li>
            <li>
                <h3 class="text-highlighted inline-block font-bold">Communication and transfer of Data</h3>
                <p class="my-4">
                    The data may also be processed by contractors that are engaged in activities related to, supportive of, or instrumental to those
                    of Adorea S.r.l. (Fleequid), acting as data processors under the instructions of Adorea S.r.l. (Fleequid). If data is transferred
                    to countries outside the European Economic Area, Adorea S.r.l. (Fleequid) will ensure compliance with its privacy policy and
                    applicable data protection regulations.
                </p>
            </li>
            <li>
                <h3 class="text-highlighted inline-block font-bold">Data Retention</h3>
                <p class="my-4">
                    Your data will be retained for the minimum duration required to fulfill the purposes outlined in point 1 above, specifically, 10
                    years from the conclusion of the contract's effects. This retention period is justified, particularly for marketing purposes, due
                    to the specialized nature of the goods involved in the auctions administered by Adorea S.r.l. (Fleequid), namely, high-value
                    industrial vehicles. Upon expiration of this timeframe, the data will be either deleted or anonymized.
                </p>
            </li>
            <li>
                <h3 class="text-highlighted inline-block font-bold">Rights of the data subject</h3>
                <p class="my-4">
                    Data subject rights include the ability to access their data and related information such as the purpose of processing, categories
                    of personal data, recipients or categories of recipients to whom the data may be disclosed, and data retention period according to
                    Art. 15 GDPR. Additionally, they have the right to rectify inaccurate data (Art. 16 GDPR), request data deletion (Art. 17 GDPR),
                    restrict processing (Art. 18 GDPR), and obtain data portability (Art. 20 GDPR). They can also object to processing, including for
                    marketing purposes, under Art. 21 GDPR. If you wish to lodge a complaint with the Data Protection Authority, you can always do so
                    using the procedures outlined on
                    <NuxtLink class="text-primary hover:underline" to="https://www.garanteprivacy.it" target="_blank" external>
                        www.garanteprivacy.it</NuxtLink
                    >.
                </p>
                <p class="my-4">
                    For any inquiries or concerns about our privacy policies, please reach out to us at
                    <FleequidEmailLink type="privacy" />. We promptly address all requests from users seeking to exercise their data protection rights
                    in compliance with relevant laws.
                </p>
            </li>
        </BaseVerticalStack>
    </ContentPage>
</template>
